import React, { useState, Fragment } from 'react'
import { string } from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import CopyTextOnClick from 'Pods/Shared/CopyTextOnClick'

import CheckoutShareModal from './CheckoutShareModal'

function CheckoutShare({ type = '' }) {
  const [isOpen, setIsOpen] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [cartPath, setCartPath] = useState('')

  const shareIcon = <Icon type={['fas', 'share']} />

  function onFetchSuccess({ data: { url } }) {
    setIsDisabled(false)
    setCartPath(url)
    setIsOpen(true)
  }

  function onFetchFailure() {
    App.events.publish('app:notification:flash:error', 'Unfortunately cart couldn\'t be shared')
  }

  function fetchSharePath() {
    if (!type) {
      setIsDisabled(true)
    }

    const url = `/${type}/checkout/build-shareable-cart`

    window.axios.post(url, {})
      .then(onFetchSuccess)
      .catch(onFetchFailure)
  }

  function flashSuccess() {
    window.App.events.publish('app:notification:flash:success', 'Your link has been copied!')
  }

  return (
    <Fragment>
      <button
        className="cgt-button cgt-button--ghost cgt-button--icon cgt-button--small"
        onClick={() => {
          fetchSharePath()
        }}
        disabled={isDisabled}
      >
        {shareIcon}
        <span>Share your cart</span>
      </button>

      {isOpen && cartPath && (
        <CheckoutShareModal
          headerIcon={shareIcon}
          onClose={() => { setIsOpen(false) }}
          header="Share your cart"
        >
          <div className="cgt-input">
            <label htmlFor="share-cart">
              Shareable link
            </label>
            <div className="cgt-input__field-wrap">
              <input
                type="text"
                placeholder="Text label"
                id="share-cart"
                defaultValue={cartPath}
                onChange={(e) => { setCartPath(e.target.value) }}
              />
            </div>
          </div>
          <CopyTextOnClick
            id="share-cart-copy-button"
            text={cartPath}
            isWithTooltip={false}
          >
            <button
              className="cgt-button cgt-button--primary cgt-button--icon cgt-button--width-expand"
              onClick={() => {
                flashSuccess()
                setIsOpen(false)
              }}
            >
              Copy link
            </button>
          </CopyTextOnClick>
        </CheckoutShareModal>
      )}
    </Fragment>
  )
}

CheckoutShare.propTypes = {
  type: string,
}

export default CheckoutShare
